import script from "./Admin.vue?vue&type=script&setup=true&lang=ts"
export * from "./Admin.vue?vue&type=script&setup=true&lang=ts"

import "./Admin.vue?vue&type=style&index=0&id=7153fc94&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7153fc94"]])

export default __exports__